import { Injectable }                  from '@angular/core';
import { UntypedFormGroup }            from '@angular/forms';
import { ENTITY_TYPE }                 from '@app/core/interfaces/entity.interface';
import { IFormBaseData }               from '@app/core/interfaces/form.interface';
import { ModalService }                from '@app/core/modals/modal.service';
import { SelectVersionModalComponent } from '@app/core/modals/select-version-modal/select-version-modal.component';
import { ModalIdentifierEnum }         from '@core/modals/modal.model';


@Injectable()
export class SelectVersionModalService {

	constructor(
		private modalService: ModalService
	) {}

	selectVersion( dbVersionEntity: ENTITY_TYPE, localVersionEntity: ENTITY_TYPE, form: UntypedFormGroup, formConfigData: IFormBaseData ) {
		return this.modalService.createModal(
			SelectVersionModalComponent,
			[
				{ key: 'dbVersion', value: dbVersionEntity },
				{ key: 'form', value: form },
				{ key: 'formConfigData', value: formConfigData },
				{ key: 'localVersion', value: localVersionEntity },
				{ key: 'modalIdentifier', value: ModalIdentifierEnum.SELECT_VERSION }
			],
			null,
			null,
			null,
			{
				asFullpage: {
					animation: true
				}
			}
		);
	}
}
